import React from 'react';
import { ReactComponent as FileCopyIcon } from '@lifesize/ux-assets/vectors/svgIcons/file-copy.svg';
import classes from './AddParticipantDrawer.module.scss';

interface Props {
  handleClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const FileCopyButton = (props: Props) => (
  <button className={classes.copyButton} onClick={props.handleClick}>
    <FileCopyIcon className={classes.icon} />
  </button>
);

export default FileCopyButton;
